import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import InfoWhiteIcon from "../../../../assets/icons/info-purple.svg";
import "./FreeSubscriptionPaymentInfoModal.less";

export type FreeSubscriptionPaymentInfoModalProps = {
  onClose: () => void;
  creatorName?: string;
};

const FreeSubscriptionPaymentInfoModal: React.FC<FreeSubscriptionPaymentInfoModalProps> = ({ onClose, creatorName }) => {
  const { t } = useTranslation();

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  const handleOverlayClick = () => {
    onClose?.();
  };

  const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
  };

  return (
    <div className="free-subscription-payment-info-bottom-modal-overlay" onClick={handleOverlayClick}>
      <div className="free-subscription-payment-info-bottom-modal-content" onClick={handleModalClick}>
        <div className="modal-header-line-wrapper">
          <div className="modal-header-line"></div>
        </div>

        <div className="free-subscription-payment-info-bottom-modal-scrollable">
          <img src={InfoWhiteIcon} className="free-subscription-payment-info-bottom-modal-icon" alt="Info" />

          <div className="free-subscription-payment-info-section-title">{t("how-does-free-subscription-work")}</div>

          <div className="free-subscription-payment-info-description">{t("free-subscription-payment-description", { creatorName })}</div>
        </div>

        <div className="free-subscription-payment-info-bottom-modal-footer">
          <button className="free-subscription-payment-info-bottom-modal-accept-button" onClick={onClose}>
            {t("i-understand")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FreeSubscriptionPaymentInfoModal;
